import { render, staticRenderFns } from "./ForumDialogComponent.vue?vue&type=template&id=da3f164a&scoped=true"
import script from "./ForumDialogComponent.vue?vue&type=script&lang=js"
export * from "./ForumDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3f164a",
  null
  
)

export default component.exports